import React, {ReactNode} from 'react';
import styled from 'styled-components'

type TimelineCardProps = {
    orientation: "right" | " left",
    image:string
    alt: string
    children: ReactNode
}

const Content = styled.div<{orientation}>`
    display: flex ;
    align-items: center;
    justify-content:${props=>props.orientation === "right" ? "flex-end" : 'flex-start'};
    margin-${props=>props.orientation}: 2.7rem;
    max-height: 110px;

    @media(max-width:768px) {
        margin-${props=>props.orientation}: 1.4rem;
    }

    .img {
        display: flex ;
        align-items: center;
        justify-content: center;
        width: 58px;
        height: 58px;
        background: #FE8418;
        border-radius: 50%;
        position: relative;
        z-index: 99;
    }

    .border-dotted {
        width: 3rem;
        height: 2px;
        border-bottom:  2px dotted #FE8418;
    }

    .content {
        width: 21.875rem;
        display: flex ;
        align-items: center;
        justify-content: center;
        border-radius: 1rem;


        box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.25);

        position: relative;

        p {
            margin: 1rem;
            font-size: 1.125rem;
            text-align: ${props => props.orientation === 'right' ? 'left' : 'right' };

            &:before {
                content: "";
                width: 12px;
                max-height: 120px;
                height:100%;
                background: linear-gradient(180deg, #FE8418 85.29%, rgba(254, 132, 24, 0) 100%);
                position: absolute;
                top:42%;
                ${props=>props.orientation === "right" ? 'left' : 'right'}: -24%;
            }

            @media (max-width:768px){
                font-size: 1rem;

                &:before {
                height: 120px;
                top:25%;
                ${props=>props.orientation === "right" ? 'left' : 'right'}: -32%;
            }

            }
        }
    }

    @media (max-width:768px){
        .content {
            width: 16rem;

            p {
                font-size: .7rem;
            }
        }
    }
`

export const ContentMobile = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;



    .img {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 58px;
        height: 58px;
        background: #fe8418;
        border-radius: 50%;
        position: relative;
        z-index: 99;
    }

    .content {
        width: 19rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1rem;
        margin: 1rem;

        box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.25);

        p {
            padding: 0.5rem;

            font-size: 1rem;
        }
    }

    @media(max-width: 320px){

        .content {
            width: 16rem;

            p {
                font-size: 0.9rem;
            }
        }

    }

`

export const TimelineCard = ({orientation, children, image, alt}:TimelineCardProps) => {
  return (
      <>
        {orientation === 'right' ? (
             <Content orientation={orientation}>
                 <div className="img">
                    <img src={image} alt={alt} />
                 </div>

                <div className="border-dotted"/>

                <div className="content">
                    {children}
                </div>
             </Content>
        ) : (
            <Content orientation={orientation}>
                <div className="content">
                    {children}
                </div>

                <div className="border-dotted"/>

                <div className="img">
                    <img src={image} alt={alt} />
                </div>
            </Content>
        )}
      </>
  )
}

export const TimelineCardMobile = ({children, image, alt}) => {

    return (
        <ContentMobile>
            <div className="img">
              <img src={image} alt={alt} />
            </div>

            <div className="content">
              {children}
            </div>
        </ContentMobile>
    )
}
